import dbGateway from '@/api/dbGateway';


const model = {

  getPeriodList(param = {}) {
    return dbGateway.post('/bs-client/bs/sys/period/list', param);
  },

  
  savePeriod(param = {}) {
    if (param.id) {
      return dbGateway.post('/sys/period/modify', param);
    }
    return dbGateway.post('/sys/period/create', param);
  },

  
  getPeriodById(param = {}) {
    return dbGateway.get(`/sys/period/${param.id}`);
  },

  
  deletePeriodById(param = {}) {
    return dbGateway.post('/sys/period/remove', param);
  },

  
  checkPeriodName(param = {}) {
    return dbGateway.post('/sys/period/checkPeriodName', param);
  },
};

export default model;
